import { render, staticRenderFns } from "./SetAddress.vue?vue&type=template&id=65fcc788&scoped=true&"
import script from "./SetAddress.vue?vue&type=script&lang=js&"
export * from "./SetAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fcc788",
  null
  
)

export default component.exports